export class UpdateLocalizedValueEvent {
  private _path: string;
  private _value: string;

  constructor(path: string, value: string) {
    this._path = path;
    this._value = value;
  }

  get path(): string {
    return this._path;
  }

  get value(): string {
    return this._value;
  }
}
